import React from "react";

const Loading = ({className}) => {
  return (
    <div className="flex justify-center items-center w-full py-10">
      <div
        className={`w-12 h-12 ${className} border-4 border-green-500 border-t-transparent rounded-full animate-spin`}
        role="status"
      >
        <span className="sr-only">Đang tải...</span>
      </div>
    </div>
  );
};

export default Loading;
